import { createRoute } from '@tanstack/react-router'

import { DynamicRouteParameterWPrefix } from 'config/routing'
import { JSON } from 'domains/Workspaces/Images/Image'
import { imagesRoute } from 'pages/NWPlatform/Workspaces/Workspace/Images'
import { Structure } from 'pages/NWPlatform/Workspaces/Workspace/Images/Image/Structure'

export const imageRoute = createRoute({
  getParentRoute: () => imagesRoute,
  path: DynamicRouteParameterWPrefix.IMAGE_ID,
  loader: () => ({
    crumb: {
      title: null,
    },
  }),
})

export const imageLayoutRoute = createRoute({
  getParentRoute: () => imageRoute,
  id: 'imageLayout',
  component: Structure,
})

export const rawRoute = createRoute({
  getParentRoute: () => imageLayoutRoute,
  path: '/',
  component: JSON,
})
